var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalInactiveStudios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.615234 4.75781V8.81836H3.17871H5.74219V9.06445V9.31055H4.40918H3.07617V9.55664V9.80273H5.45508H7.83398V8.69531V7.58789H4.69629H1.55859V4.63477V1.68164H6.93164H12.3047V3.73242V5.7832H12.7764H13.248V3.24023V0.697266H6.93164H0.615234V4.75781Z",
    fill: "#006AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 8.44922V10.623H8.83887H9.31055V8.9209V7.21875H14.6836H20.0566V10.1924V13.166H16.6318H13.207V13.7813V14.3965H13.3711H13.5352V14.6426V14.8887H13.3711H13.207V15.1143V15.3398H15.8115H18.416V15.1143V14.8887H17.083H15.75V14.6426V14.3965H18.375H21V10.3359V6.27539H14.6836H8.36719V8.44922Z",
    fill: "#006AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2578V19.3184H2.56348H5.12695V19.5645V19.8105H3.77344H2.41582L2.42812 20.0443L2.44043 20.2822L6.22617 20.2945L10.0078 20.3027V20.0566V19.8105H8.69531H7.38281V19.5645V19.3184H10.0078H12.6328V15.2578V11.1973H6.31641H0V15.2578ZM11.6895 15.1348V18.0879H6.31641H0.943359V15.1348V12.1816H6.31641H11.6895V15.1348Z",
    fill: "#006AB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInactiveStudios);
export default __webpack_public_path__ + "static/media/total_inactive_studios.96e3e1e264a2c0942781ac9bb5410a5e.svg";
export { ForwardRef as ReactComponent };